import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import RegisterComponent from './register.component';

let RegisterModule = angular
  .module('Register', [
    uiRouter
  ])
  .component('register', RegisterComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('register', {
      url: '/register',
      views: {
        'menu': "",
        'content': {
          component: 'register'
        }
      }
    });
  })
  .name;

export default RegisterModule;



// WEBPACK FOOTER //
// ./src/app/pages/register/register.module.js